import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';
import { HttpService } from '../../utility/http-service';
import { RouterService } from '../../utility/router-service';
import { DialogService } from '../../utility/dialog/dialog-service';
import { ModalType } from '../../utility/dialog-template/dialog-template.component';

@Component({
  selector: 'rejected-users',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './rejected-users.component.html',
  styleUrl: './rejected-users.component.css'
})
export class RejectedUsersComponent {

  @ViewChild('rejectedGrid') rejectedGrid?: WcGridComponent;

  selectedUser: any = null;

  constructor(
    private http: HttpService,
    private router: RouterService,
    private dialogService: DialogService
  ) {}

  onUserSelected(row: any): void {
    this.selectedUser = row;
  }

  approveUser(): void {
    const record = this.selectedUser;
    if (!record) return;
    this.dialogService.openModal(
      'Approve User',
      `Are you sure you want to approve ${record.Email} for login?`,
      ModalType.QUESTION,
      () => {
        const formData = new FormData();
        formData.append('id', record.Id);
        this.http.post('User/ApproveUser', () => this.router.reloadPage(), null, formData);
      },
      () => {}
    );
  }
}
